import { useEffect } from "react"
import { CustomButton } from "../components"
import { COLORS } from "../constants"
import { useHistory } from 'react-router-dom'

import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { useState } from "react"
import { SelectGamesModal } from "../components"
import Confetti from 'react-dom-confetti';
import ReactAudioPlayer from 'react-audio-player';
import Logo from "../assets/images/logo.png"
import styled from "styled-components"
import grass from "../assets/images/grass.svg"
import Helmet from "react-helmet"
import useSound from "use-sound";
import Loading from "./Loading"
import victory from "../assets/audio/Victory.mp3"
import axios from "axios"

import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Mousewheel, Autoplay } from 'swiper';


SwiperCore.use([Navigation, Mousewheel, Autoplay]);


const StyledInfo = styled.div`
    position: absolute;
    top: 20px;
    left: 40px;
`;

const config = {
    angle: 90,
    spread: 360,
    startVelocity: 40,
    elementCount: 70,
    dragFriction: 0.12,
    duration: 5000,
    stagger: 10,
    width: "10px",
    height: "10px",
    perspective: "500px",
    colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"]
};
const WhiteCard = styled.div`
  background-color: white;
  border-radius: 10px;

`;
const StyledListItem = styled.div`
    padding: 10px;
    border-radius: 10px;
    margin-top: 15px;

`;
function Results(props) {
    const history = useHistory();
    const api = process.env.REACT_APP_API_URL;
    const userFull = useSelector(state => state.auth.user)
    const [play] = useSound(victory, { interrupt: true, volume: 0.5 });
    const [resultQuestions, setResultQuestions] = useState([]);
    const [score, setScore] = useState(-1);
    const [activeConfetti, setActiveConfetti] = useState(false);
    const [loading, setLoading] = useState(true)
    const [gamesModal, setGamesModal] = useState(false);

    const { levelno, gameno } = props.match.params;

    useEffect(() => {
        setActiveConfetti(true);
        axios.get(`${api}/cp/game_score/${userFull.user.pupil_id}/${levelno}/${gameno}`, {}, {
            headers: {
                'Accept': 'application/json'
            }
        }).then(res => {
            const result = res.data;
            setResultQuestions(result.questions)
            setScore(result.total_score)
            setTimeout(() => {
                if (result.total_score == "6") {
                    play();
                }

                setLoading(false)
            }, 1000)

        }).catch(error => {
            console.log(error);
        });

    }, [play]);
    return (
        <div>
            <Loading visible={loading} />

            <ReactAudioPlayer
                src="../assets/audio/Victory.mp3"

                autoPlay={true}

            />
            <Helmet>
                <style type="text/css">{`
                    body {
                        background-color: #3290B5;
                    }
                `}</style>
            </Helmet>

            <StyledInfo className="d-none d-lg-block">
                <Link to="/dashboard">
                    <img src={Logo} width={180} height={45} />
                </Link>
                <div className="text-white">Level {levelno} • Game {gameno}</div>
            </StyledInfo>
            <div className="h-100 d-flex justify-content-center align-items-start">
                <Confetti active={activeConfetti} config={config} />
                <WhiteCard className="results-card p-5">
                    {score >= 0 &&
                        <Swiper navigation={{ nextEl: '.next', prevEl: '.prev' }} autoHeight={true}>

                            <SwiperSlide>
                                <div className="color-text-grey text-center">Level {levelno} • Game {gameno}</div>
                                <h3 className="text-center mt-3">{score == 3 || score == 4 ? 'Good Try!' : score == 5 ? 'Well Done!' : score == 6 ? 'Congratulations!' : "Your Score"}</h3>

                                <h1 className="text-center mb-0 mt-3" style={{ fontSize: 80 }}>
                                    <span className="color-orange">{score}</span><span className="color-dark-orange">/6</span>
                                </h1>
                                {/* <div className="text-center color-text-dark-blue" style={{ marginTop: -8 }}>
                                    Total Score
                            </div> */}
                                <div className="mt-3">
                                    <CustomButton
                                        bgColor={COLORS.green}
                                        hover={COLORS.text_green}
                                        className="mt-4 next"
                                        color={COLORS.text_dark_green}
                                        style={{ padding: "0 15px", height: 80, fontSize: 17, width: "100%" }}
                                    >
                                        Review Answers
                                </CustomButton>
                                    {score < 6 && <CustomButton
                                        bgColor={COLORS.green}
                                        hover={COLORS.text_green}
                                        className="mt-4"
                                        onClick={() => history.replace('/dashboard/try_again')}
                                        color={COLORS.text_dark_green}
                                        style={{ padding: "0 15px", height: 80, fontSize: 17, width: "100%" }}
                                    >
                                        Let's Go Again Bucket
                                </CustomButton>}


                                    <CustomButton
                                        bgColor={COLORS.green}
                                        hover={COLORS.text_green}
                                        className="mt-4"
                                        onClick={() => setGamesModal(true)}
                                        color={COLORS.text_dark_green}
                                        style={{ padding: "0 15px", height: 80, fontSize: 17, width: "100%" }}
                                    >
                                        Play Another Game
                                </CustomButton>

                                    <CustomButton
                                        bgColor={COLORS.green}
                                        hover={COLORS.text_green}
                                        className="mt-4"
                                        onClick={() => history.replace('/dashboard')}
                                        color={COLORS.text_dark_green}
                                        style={{ padding: "0 15px", height: 80, fontSize: 17, width: "100%" }}
                                    >
                                        Exit
                                </CustomButton>

                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="color-text-grey text-center">Level {levelno} • Game {gameno}</div>
                                <h3 className="text-center mt-3">Results</h3>
                                <div style={{ overflow: "scroll", height: 400 }}>
                                    {resultQuestions.map((result, i) => {
                                        return <StyledListItem style={{ backgroundColor: result.passed == 1 ? "rgba(157, 187, 19, 0.2)" : "rgba(255, 0, 0, 0.1)" }} key={i}>
                                            <h5 style={{ color: result.passed == 1 ? "#9DBB13" : "red" }}>• Question {i + 1}</h5>
                                            <div>{result.clue}</div>
                                            <div className="d-flex justify-content-between">
                                                {result.passed == 1 ? <><div style={{ fontSize: 15 }}>Answer: <span className="color-text-green ml-1" style={{ fontSize: 20 }}>{result.word}</span></div></> : <> <div style={{ fontSize: 15 }}>Correct Answer: <span className="color-text-green ml-1" style={{ fontSize: 20 }}>{result.word}</span></div>
                                                    <div style={{ fontSize: 15 }}>Your Answer: <span className="ml-1" style={{ fontSize: 20, color: "red" }}>{result.answer}</span></div></>}

                                            </div>
                                        </StyledListItem>
                                    })}
                                </div>
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <div>
                                        <div>Total Score</div>
                                        <h4 className="mb-0"><span className="color-orange">{score}</span><span className="color-dark-orange">/6</span></h4>
                                    </div>
                                    <CustomButton
                                        bgColor={COLORS.green}
                                        hover={COLORS.text_green}
                                        className="prev"
                                        color={COLORS.text_dark_green}
                                        style={{ padding: "0 15px", height: 50, fontSize: 17, width: 100 }}
                                    >
                                        Go Back
                                </CustomButton>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    }
                </WhiteCard>
            </div>
            {/* Used in practice for simplification, it does not mean it will show practice games */}
            <SelectGamesModal mode={2} selectedLevelProps={levelno} modalVisible={gamesModal} onClose={() => setGamesModal(false)} />
        </div>
    );
}

export default Results;